import type { CSSProperties } from 'react';
import { alpha, Theme } from '@mui/material/styles';

type JeopardyThemeCSSVariables = CSSProperties & Record<string, string>;

export function getJeopardyThemeVars(theme: Theme): JeopardyThemeCSSVariables {
    const accent = theme.palette.warning.main;
    const isDark = theme.palette.mode === 'dark';

    return {
        '--j-bg': theme.palette.background.default,
        '--j-surface': theme.palette.background.paper,
        '--j-card': isDark ? alpha(theme.palette.common.white, 0.08) : alpha(theme.palette.common.white, 0.92),
        '--j-border': theme.palette.divider,
        '--j-text': theme.palette.text.primary,
        '--j-muted': theme.palette.text.secondary,
        '--j-gold': accent,
        '--j-gold-dim': alpha(accent, isDark ? 0.18 : 0.14),
        '--j-green': theme.palette.success.main,
        '--j-red': theme.palette.error.main,
        '--j-indigo': theme.palette.info.main,
        '--j-played': isDark ? alpha(theme.palette.common.black, 0.28) : alpha(theme.palette.text.primary, 0.08),
        '--j-card-hover': alpha(accent, isDark ? 0.22 : 0.12),
        '--j-overlay': alpha(theme.palette.background.paper, isDark ? 0.94 : 0.96),
        '--j-success-dim': alpha(theme.palette.success.main, 0.15),
        '--j-error-dim': alpha(theme.palette.error.main, 0.15),
        '--j-accent-contrast': theme.palette.getContrastText(accent),
        '--j-input-bg': isDark ? alpha(theme.palette.common.black, 0.16) : theme.palette.common.white,
        '--j-font': "'ITC Korinna', 'Merriweather', Georgia, serif",
        '--j-radius': '8px',
        '--j-shadow': isDark ? '0 4px 24px rgba(0,0,0,0.5)' : '0 4px 24px rgba(15,23,42,0.15)',
    };
}
